module.exports = __webpack_public_path__ + "static/media/default.c7122ed3.svg";